import React from 'react'
import PropTypes from 'prop-types'
import { Label, Table, Loader } from 'semantic-ui-react'
import { Link } from 'react-router-dom'

import { CRUDIndex } from '../CRUD'
import { EditDeleteButtonContainer } from '../../containers'

const Uf = (props) => (
  <CRUDIndex
    title='Unidades Federativas'
    icon='marker'
    onRedirectToNew={props.onRedirectToNew}
    onExportToCSV={props.onExportToCSV}
    filterText={props.filterText}
    handleFilter={props.handleFilter}
  >
    <Table sortable celled striped selectable>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width={1} textAlign='center'
            onClick={props.handleSort('id')}
            sorted={props.handleSorted('id')}>#</Table.HeaderCell>
          <Table.HeaderCell
            onClick={props.handleSort('nome')}
            sorted={props.handleSorted('nome')}>Nome</Table.HeaderCell>
          <Table.HeaderCell width={2} textAlign='center'
            onClick={props.handleSort('sigla')}
            sorted={props.handleSorted('sigla')}>Sigla</Table.HeaderCell>
          <Table.HeaderCell width={2} textAlign='center'
            onClick={props.handleSort('submercado.nome')}
            sorted={props.handleSorted('submercado.nome')}>Submercado</Table.HeaderCell>
          <Table.HeaderCell width={1}></Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {props.isLoading && (
          <Table.Row>
            <Table.Cell colSpan='5'>
              <Loader active={props.isLoading} inline='centered' />
            </Table.Cell>
          </Table.Row>
        )}
        {props.multipleUf.valueSeq().map((uf, index) => (
          <Table.Row key={index}>
            <Table.Cell textAlign='center'>
              <Label as={Link} to={`/uf/${uf.get('id')}`}>{uf.get('id')}</Label>
            </Table.Cell>
            <Table.Cell>{uf.get('nome')}</Table.Cell>
            <Table.Cell textAlign='center'>{uf.get('sigla')}</Table.Cell>
            <Table.Cell textAlign='center'>
              {uf.get('submercado') ? (
                <Label as={Link} to={`/submercados/${uf.getIn(['submercado', 'id'])}`}>
                  {uf.getIn(['submercado', 'nome'])}
                </Label>
              ) : (
                <em>N/A</em>
              )}
            </Table.Cell>
            <Table.Cell>
              <EditDeleteButtonContainer
                onEditResource={() => props.onEditResource(uf.get('id'))}
                onDeleteResource={() => props.onDeleteResource(uf.get('id'))} />
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  </CRUDIndex>
)

Uf.propTypes = {
  onRedirectToNew: PropTypes.func,
  multipleUf: PropTypes.object,
  onEditResource: PropTypes.func,
  onDeleteResource: PropTypes.func,
  handleSort: PropTypes.func,
  handleSorted: PropTypes.func,
  filterText: PropTypes.string,
  handleFilter: PropTypes.func,
  onExportToCSV: PropTypes.func,
  isLoading: PropTypes.bool,
}

export default Uf
